// extracted by mini-css-extract-plugin
export default {"submit-btn":"styles_submit-btn__utqme"};